import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

export const Times = styled.div`
  position: absolute;
  top: 2.4rem;
  left: 2.4rem;
`;

export const LapTimes = styled.div``;

export const Ui = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  column-gap: 1rem;
  bottom: 2.4rem;
  left: 2.4rem;
`;

export const Sound = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1rem;
`;

export const SoundItems = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
`;

export const SoundItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1rem;
`;

export const H3 = styled.h3``;
